export const onRenderMarkdown = (rawText: string) => {
    let html = rawText.replace(
        /^([^\n]*?\|[^\n]*?\n)([-:| ]+\|[-:| ]+\n)((?:(?:[^\n]*?\|[^\n]*?)(?:\n|$))+)/gm,
        (_, headers, dividers, rows) => {
            const headerCells = headers
                .split('|')
                .map((cell: string) => `<th>${cell.trim()}</th>`)
                .join('')

            const tableRows = rows
                .trim()
                .split('\n')
                .map((row: string) => {
                    const cells = row
                        .split('|')
                        .map((cell: string) => `<td>${cell.trim()}</td>`)
                        .join('')
                    return `<tr>${cells}</tr>`
                })
                .join('')

            return `<table class="markdown-table"><thead><tr>${headerCells}</tr></thead><tbody>${tableRows}</tbody></table>`
        }
    )

    html = html
        .replace(/^# (.*$)/gm, '<h1 class="markdown-h1">$1</h1>')
        .replace(/^## (.*$)/gm, '<h2 class="markdown-h2">$1</h2>')
        .replace(/^### (.*$)/gm, '<h3 class="markdown-h3">$1</h3>')
        .replace(/^#### (.*$)/gm, '<h4 class="markdown-h4">$1</h4>')
        // .replace(/\*\*(.*?)\*\*/g, '<strong class="markdown-strong">$1</strong>')
        // .replace(/\*(.*?)\*/g, '<em class="markdown-em">$1</em>')
        // .replace(/!\[(.*?)\]\((.*?)\)/g, '<img src="$2" alt="$1" class="markdown-img" />')
        .replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" class="markdown-a">$1</a>')
        // .replace(/^\s*\*\s(.*$)/gm, '<li class="markdown-li">$1</li>')
        // .replace(/(<li class="markdown-li">.*<\/li>)/gs, '<ul class="markdown-ul">$1</ul>')
        // .replace(/^\s*\d+\.\s(.*$)/gm, '<li class="markdown-li">$1</li>')
        // .replace(/(<li class="markdown-li">.*<\/li>)/gs, (match) => {
        //     // Проверяем, не обернуты ли уже в ul/ol
        //     if (!match.includes('<ul') && !match.includes('<ol')) {
        //         return `<ol class="markdown-ol">${match}</ol>`
        //     }
        //     return match
        // })
        // .replace(/`(.*?)`/g, '<code class="markdown-code">$1</code>')
        .replace(
            /\[\(([\s\S]*?)\)\]/g,
            (_, content) => `<div class="custom-markdown-block">${content.replace(/\n/g, '<br />')}</div>`
        )

    return html
}
